import { render, staticRenderFns } from "./SubQuestion.vue?vue&type=template&id=36c359d8"
import script from "./SubQuestion.vue?vue&type=script&lang=js"
export * from "./SubQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports